<template>
  <a-config-provider :locale="zhCN">
    <router-view></router-view> <!-- 路由视图 -->
  </a-config-provider>

</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'; // 引入中文语言包
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      zhCN
    }
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
</style>
